import React, { Component } from 'react';
import moment from 'moment'
import firebase from '../../firebase/config'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBInput } from 'mdbreact';

import Validation from './filterPassword/filterPass'

import { connect } from 'react-redux'
import fetchPassword from '../../actions/fetchPassword'

class ModalPage extends Component {
    componentDidMount() {
        let status = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{4,}$/.test(this.props.passwordData)
        this.setState({
            passData: {
                username: this.props.usernameData,
                website: this.props.websiteData,
                password: {
                    data: this.props.passwordData,
                    valid: status
                },
                url: this.props.urlData
            }
        })
    }
    state = {
        modal: false,
        passData: {
            username: '',
            website: '',
            password: {
                data: '',
                valid: false
            },
            url: ''
        }
    };
    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }
    onDelete = () => {
        let self = this
        firebase.database().ref(`users/${localStorage.getItem('uid')}/vaults/${self.props.vault}/${self.props.passwordId}`).remove()
            .then(data => {
                self.toggle()
                self.props.fetchPassword(localStorage.getItem('uid'), self.props.vault)
            })
            .catch(err => {
                console.log(err)
                alert('err while deleting')
            })
    }
    changeHandler = (e) => {
        let self = this
        let data = {
            ...self.state.passData,
            [e.target.name]: e.target.value
        }
        this.setState({
            passData: data
        })

    }
    changePassword = (e) => {
        let self = this
        let status = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{4,}$/.test(e.target.value)
        let data = null
        if (status) {
            data = {
                ...self.state.passData,
                password: {
                    data: e.target.value,
                    valid: true
                }
            }
        } else {
            data = {
                ...self.state.passData,
                password: {
                    data: e.target.value,
                    valid: false
                }
            }
        }
        self.setState({
            ...self.state,
            passData: data
        })
    }

    onSubmitAdd = (e) => {
        e.preventDefault()
        e.target.className += " was-validated";
        let self = this
        if (this.props.actions === 'addNewPassword' && this.state.passData.password.valid) {
            let pass = {
                ...self.state.passData,
                createdAt: moment().format('L'),
                updatedAt: moment().format('L'),
                password: self.state.passData.password.data
            }
            firebase.database().ref(`users/${localStorage.getItem('uid')}/vaults/${this.props.vault}`).push(pass)
                .then(data => {
                    self.setState({
                        passData:
                        {
                            username: '',
                            website: '',
                            password: {
                                data: '',
                                valid: false
                            },
                            url: ''
                        }
                    })
                    self.toggle()
                    self.props.fetchPassword(localStorage.getItem('uid'), self.props.vault)
                })
                .catch(err => {

                })
        } else if (this.props.actions === 'editPassword' && this.state.passData.password.valid) {
            let data = {
                ...self.state.passData,
                createdAt: self.props.createdAtData,
                password: self.state.passData.password.data,
                updatedAt: moment().format('L')
            }
            firebase.database().ref(`users/${localStorage.getItem('uid')}/vaults/${self.props.vault}/${self.props.passwordId}`).update(data)
                .then(data => {
                    self.toggle()
                    self.props.fetchPassword(localStorage.getItem('uid'), self.props.vault)
                })
                .catch(err => {
                    console.log(err)
                    alert('err while update')
                })
        }
    }
    render() {
        return (
            <MDBContainer>
                {/* BUTTON */}
                <MDBBtn color={this.props.btnColor} size={this.props.btnSize} onClick={this.toggle}>{this.props.btnTitle}</MDBBtn>

                {/* MODAL */}
                <MDBModal isOpen={this.state.modal} toggle={this.toggle}    >
                    <MDBModalHeader toggle={this.toggle}>{this.props.modalTitle}</MDBModalHeader>
                    <form className="needs-validation" onSubmit={this.onSubmitAdd} >
                        <MDBModalBody>
                            <div className="row">
                                <div className="col-md-10">
                                    <MDBInput required type="text" onChange={this.changeHandler} name='website' value={this.state.passData.website} label="Website Name" icon="globe" />
                                    <MDBInput required name='username' onChange={this.changeHandler} value={this.state.passData.username} label="Username/email" icon="user" />
                                    <MDBInput required className={this.state.passData.password.valid ? 'is-valid' : 'is-invalid'} required pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{4,}$" name='password' onChange={this.changePassword} value={this.state.passData.password.data} label="Password" icon="lock" >
                                        <div className="valid-feedback">Looks good!</div>
                                        <div className="invalid-feedback">Password atleast must have one uppercase letter, one lowercase letter, special character, one number and more than 4 characters </div>
                                    </MDBInput>
                                    <MDBInput required name='url' onChange={this.changeHandler} value={this.state.passData.url} label="URL" icon="link" />
                                </div>
                            </div>

                            <Validation password={this.state.passData.password.data} />

                        </MDBModalBody>
                        <MDBModalFooter>
                            {
                                this.props.actions === 'addNewPassword'
                                    ? <MDBBtn type="submit" color="primary">Save</MDBBtn>
                                    : this.props.actions === 'editPassword' ? <div><MDBBtn onClick={this.onDelete} color="danger">Delete Data</MDBBtn><MDBBtn type="submit" color="primary">Update Data</MDBBtn></div>
                                        : null
                            }

                        </MDBModalFooter>
                    </form>
                </MDBModal>
            </MDBContainer>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPassword: (uid, vault) => dispatch(fetchPassword(uid, vault))
    }
}
export default connect(null, mapDispatchToProps)(ModalPage);